export function waitForMessage(worker: Worker, dataId: string): Promise<number[]> {
    return new Promise((resolve) => {
        worker.onmessage = (e) => {
            const { result, id } = e.data;
            if (id === dataId) {
                worker.terminate();
                resolve(result);
            }
        };
    });
}
